import { h, JSX } from 'preact'
import { LocalizedName } from '../../../../domain'
import { Message } from '../../../../../lib/intl/Message'
import styles from './VissteDuAt.module.css'
import { Diagonal } from '../../../shared/Decoration'
import { bem } from '@nrk/dh-utils'

interface Props extends JSX.HTMLAttributes {
  navn: LocalizedName
  stemmeberettigede: number
  modifiers?: any
}

export function Stemmeberettigede({ navn, stemmeberettigede, modifiers }: Props) {
  const small = stemmeberettigede > 100000
  return (
    <div>
      <Message
        class={styles.intro}
        id="visste-du-at-stemmeberettigede-intro"
        values={{ navn }}
        modifiers={modifiers}
      />
      <div class={styles.mainWrapper}>
        <Diagonal class={styles.decoration} />
        <div class={bem(styles.main, { small })}>
          <Message
            class={styles.value}
            id="visste-du-at-stemmeberettigede-verdi"
            values={{ verdi: stemmeberettigede }}
          />
          <Message
            class={styles.description}
            id="visste-du-at-stemmeberettigede-verdi-beskrivelse"
          />
        </div>
      </div>
    </div>
  )
}
